import { Component } from "@angular/core";
import { Platform, ToastController } from "@ionic/angular";
import { NavigationEnd, Router } from "@angular/router";
import { ServiceWorkerUpdateService } from "./core/services/service-worker-update.service";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { Storage } from "@ionic/storage";
import { NetworkService } from "./services/network.service";
import { TokenControllerService } from "./messages-sdk/services/token-controller.service";
import { TranslateService } from "@ngx-translate/core";
import { CodebaseTranslateService } from "./services/codebase-translate.service";
import { ChannelsClientService } from "./messages-sdk/services/channels-client.service";
import { Push, PushObject, PushOptions } from "@ionic-native/push/ngx";
import { environment } from "@env/environment";
import { WeatherApiService } from "./shared/weather-api/weather-api.service";
import moment from "moment";
import { StorageService } from "./services/storage.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { CMSDataControllerService } from "./core/data/controller/cmsdata-controller.service";
import { SocialWallClientService } from "./shared/social-wall-client/social-wall-client.service";
import { DistanceUtilsService } from "./shared/services/distance-utils.service";
import { SecureUserRepositoryService } from "./core/users-api/secure-user-repository.service";
import { SharedConstantsService } from "./shared/services/shared-constants.service";
import { BasePageComponent } from "./shared/base-page/base-page.component";
import { ContentAnalyticsService } from "./services/content-analytics.service";
import { AudienceAnalyticsService } from "./services/audience-analytics.service";
import { filter } from "rxjs/operators";


declare function require(name: string);

@Component({
  selector: "app-root",
  templateUrl: require("template/" +
    environment.template +
    "/html/app.component.html"),
})
export class AppComponent extends BasePageComponent {
  public showSplash: boolean = true;
  public splashImage: string;
  weather: any;
  public mainImage: any;
  currentRegion: any;
  public environment = environment;
  bodyStyles = document.body.style;
  deferredPrompt: any;
  regions: any;
  public IBURL :SafeResourceUrl;
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private update: ServiceWorkerUpdateService,
    private router: Router,
    private storage: Storage,
    protected contentAnalytics: ContentAnalyticsService,
    private push: Push,
    private toastController: ToastController,
    private tokenController: TokenControllerService,
    private networkService: NetworkService,
    private dataController: CMSDataControllerService,
    private distanceUtils: DistanceUtilsService,
    private translate: TranslateService,
    private userRepository: SecureUserRepositoryService,
    private sharedConstants: SharedConstantsService,
    private storageService: StorageService,
    private channelService: ChannelsClientService,
    private socialWallClient: SocialWallClientService,
    private weatherApiService: WeatherApiService,
    private audienceAnalytics: AudienceAnalyticsService,
    private codebaseTranslateService: CodebaseTranslateService,
    private sanitizer: DomSanitizer
  ) {
    super(contentAnalytics)
    this.initializeApp();
    // storage.get('language').then(lang => {
    // })
  }

  ngOnInit() {
    super.ngOnInit();
    this.storageService.watchItinerarySrc().subscribe((newValue) => {
      if (newValue) {
        if (!document.URL.includes('staging') || !document.URL.includes('localhost')){
          this.IBURL = this.sanitizer.bypassSecurityTrustResourceUrl(newValue); // Realiza la lógica necesaria
        }else{
          newValue = newValue.replace('-qa', '');
          this.IBURL = this.sanitizer.bypassSecurityTrustResourceUrl(newValue); // Realiza la lógica necesaria

        }
      }
    });
    if (environment.regions.enabled){
      this.detectUserRegion();
    }else{
      this.storage.remove("activeRegion");
    }
    // Track content view
    this.contentAnalytics.trackContentView(
      'App',
      environment.theme.name,
      environment.theme.appCode
    );

  }

  async initializeApp() {
    // Track session start
    this.audienceAnalytics.trackSessionStart();
    // Set up automatic page tracking
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      const pageName = this.getPageName(event.urlAfterRedirects);
      const pageClass = this.getPageClass(event.urlAfterRedirects);

      this.audienceAnalytics.trackScreenView(pageName, pageClass);
    });

    this.IBURL = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.ItineraryBuilder.base_url}`);
    this.weatherApiService
      .getWeather({ zipCode: environment.cms.postalCode })
      .then((weather) => {
        // this.weather = {
        //   icon: this.getIconWeather(weather.Forecast.Today.Description),
        //   current: `${weather.Forecast.Today.Current}°`,
        //   date: moment().format('dddd, MMMM D, YYYY')
        // }

        // this.codebaseTranslateService.languageChange("eng");
        var timer = 0;
        var interval = setInterval(() => {
          timer++;
          if (timer < 7) {
          } else {
            clearInterval(interval);
            this.showSplash = false;
            //console.log('Done');
          }
        }, 1000);
      })
      .catch((err) => {
        console.error(err);
        this.weather = ".";

        // this.codebaseTranslateService.languageChange("eng");
        var timer = 0;
        var interval = setInterval(() => {
          timer++;
          if (timer < 7) {
          } else {
            clearInterval(interval);
            this.showSplash = false;
            //console.log('Done');
          }
        }, 1000);
      });

      this.mainImage = `/themes/${environment.theme.name}/assets/splash/background-splash.png`;
    this.bodyStyles.setProperty(
      "--image",
      `url("/themes/${environment.theme.name}/assets/splash/background-splash.png")`
    );
    this.bodyStyles.setProperty(
      "--logo",
      `url("/themes/${environment.theme.name}/assets/login/logo.png")`
    );
    this.splashImage = `../../../themes/${environment.theme.name}/assets/login/logIn_background.png`;
    // this.codebaseTranslateService.languageChange('eng')
    // this.codebaseTranslateService.initLanguage();
    if (this.networkService.getCurrentNetworkStatus() < 1) {
      const toast = await this.toastController.create({
        message: "This app is offline",
        duration: 2000,
        buttons: [
          {
            text: "Close",
            handler: () => {},
          },
        ],
      });
      toast.present();
    }
    if (this.platform.is("android")) {
      var token = await this.storage.get("pushToken");
      if (!token) this.requestPermission();
    } else if (this.platform.is("ios")) {
      var token = await this.storage.get("pushToken");
      if (!token) this.requestNotificationPermission;
    }

    const lastLocation = await this.storage.get("lastLocation");
    let promises = [];
    promises.push(this.dataController.getListings2({
      domainId: environment.cms.domainId,
      dataSyndication: false,
      latitude: lastLocation ? lastLocation.latitude : environment.cms.main_coordinates.latitude,
      longitude: lastLocation ? lastLocation.longitude : environment.cms.main_coordinates.longitude,
    }).toPromise());

    if (environment.hasSocialWall){
      promises.push(this.socialWallClient.getMedias({client_secret: environment.socialWall.client_secret, client_id: environment.socialWall.client_id}, 0, 50));
    }

    if (environment.hasEventsData){
      promises.push(this.dataController.getEvents2({
        domainId: environment.cms.domainId,
        dataSyndication: false,
        latitude: lastLocation ? lastLocation.latitude : environment.cms.main_coordinates.latitude,
        longitude: lastLocation ? lastLocation.longitude : environment.cms.main_coordinates.longitude,
      }).toPromise());
    }

    if (environment.regions.enabled){
      promises.push(this.dataController.getPageById({pageId: environment.regions.regionsPageId}).toPromise())
    }
    Promise.all(promises).then(resp => {
      this.storage.set("listings", resp[0]);
      if (environment.hasSocialWall){
        this.storage.set("medias", resp[1].Medias);
      }
      if (environment.hasEventsData){
        this.storage.set("events", resp[2]);
      }
      if (environment.regions.enabled){
        this.regions = resp[3]
        this.storage.set("regions", resp[3])
      }
    })
    // })
  }
  private getPageName(url: string): string {
    // Extract page name from URL
    const segments = url.split('/').filter(segment => segment);
    return segments.length > 0 ? segments[segments.length - 1] : 'home';
  }

  private getPageClass(url: string): string {
    // Map URL to a page class
    if (url.includes('/trails')) {
      return 'TrailsPage';
    } else if (url.includes('/events')) {
      return 'EventsPage';
    } else if (url.includes('/home')) {
      return 'HomePage';
    } else if (url.includes('/more')) {
      return 'MorePage';
    } else if (url.includes('/listings')) {
      return 'ListingsPage';
    } else if (url.includes('/connect-with-us')) {
      return 'ConnectWithUsPage';
    } else if (url.includes('/help')) {
      return 'HelpPage';
    } else if (url.includes('/me-tnt')) {
      return 'ProfilePage';
    } else if (url.includes('/login')) {
      return 'LoginPage';
    } else if (url.includes('/sign-up')) {
      return 'SignUpPage';
    } else if (url.includes('/category')) {
      return 'CategoryPage';
    } else if (url.includes('/deals')) {
      return 'DealsPage';
    } else if (url.includes('/digital-brochure')) {
      return 'BrochurePage';
    } else if (url.includes('/scavenger-hunts')) {
      return 'ScavengerHuntsPage';
    } else if (url.includes('/social-wall')) {
      return 'SocialWallPage';
    } else if (url.includes('/inbox')) {
      return 'InboxPage';
    }
    // Add other mappings
    return 'AppPage';
  }
  getIconWeather(state: string): string {
    switch (state.toLowerCase()) {
        case 'clear':
        case 'sunny':
            return '☀️';
        case 'night clear':
            return '🌙';
        case 'partly cloudy':
        case 'scattered clouds':
            return '🌤️';
        case 'clouds':
        case 'broken clouds':
        case 'few clouds':
          return '☁️';
        case 'overcast':
        case 'overcast clouds':
            return '🌥️';
        case 'rain':
        case 'shower rain':
        case 'light rain':
            return '🌧️';
        case 'heavy rain':
            return '🌧️';
        case 'storm':
        case 'thunderstorm':
        case 'light thunderstorm':
        case 'heavy thunderstorm':
        case 'thunderstorm with rain':
            return '⛈️';
        case 'drizzle':
        case 'light drizzle':
            return '🌦️';
        case 'snow':
        case 'light snow':
        case 'heavy snow':
            return '❄️';
        case 'sleet':
            return '🌨️';
        case 'mist':
        case 'haze':
            return '🌫️';
        case 'wind':
        case 'breeze':
        case 'strong breeze':
        case 'gale':
        case 'strong gale':
            return '🌬️';
        case 'fog':
            return '🌁';
        case 'smoke':
            return '🔥';
        case 'sand':
        case 'dust':
            return '🌪️';
        case 'tornado':
            return '🌪️';
        case 'hurricane':
        case 'cyclone':
        case 'typhoon':
            return '🌀';
        case 'cold':
            return '🥶';
        case 'hot':
            return '🥵';
        default:
            return '🌤️';
    }
}

async detectUserRegion() {
  try {
    const userLocation = await this.distanceUtils.getCurrentLocation();

    if (!userLocation) {
      const userZipCode = await this.userRepository.getAdditionalField(this.sharedConstants.apZipCode);

      try {
        const weather = await this.weatherApiService.getWeather({ zipCode: userZipCode });

        let region = await this.distanceUtils.findMatchingRegion(weather.Forecast.City);
        await this.storage.set("suggestedRegion", region);
        return region;
      } catch (err) {
        await this.storage.set("suggestedRegion", this.distanceUtils.findMatchingRegion(environment.regions.defaultRegion));
        return this.distanceUtils.findMatchingRegion(environment.regions.defaultRegion);
      }
    }

    const nearestRegion = this.distanceUtils.findNearestRegion(userLocation);
    await this.storage.set("suggestedRegion", nearestRegion);

    return nearestRegion;
  } catch (error) {
    console.error("Error obtaining user location:", error);
    await this.storage.set("suggestedRegion", this.distanceUtils.findMatchingRegion(environment.regions.defaultRegion));
    return this.distanceUtils.findMatchingRegion(environment.regions.defaultRegion);
  }
}

  requestNotificationPermission() {
    const options: PushOptions = {
      android: {},
      ios: {
        alert: "true",
        badge: true,
        sound: "false",
      },
    };

    const pushObject: PushObject = this.push.init(options);

    pushObject.on("registration").subscribe(async (registration: any) => {
      // console.log("Device registered", registration);
      await this.storage.set("pushToken", registration);
      await this.tokenController.registerDeviceTokenIos(registration);
      await this.channelService.postSubscribeToChannels(
        ["GlobalNotifications"],
        registration
      );
      // Aquí puedes enviar el token de registro a tu servidor para enviar notificaciones.
    });

    pushObject.on("notification").subscribe((notification: any) => {
      // console.log("Received a notification", notification);
      // Aquí puedes manejar la notificación cuando se recibe.
    });

    pushObject.on("error").subscribe((error: any) => {
      console.error("Error with Push plugin", error);
    });
  }

  requestPermission() {
    this.tokenController.requestPermission().subscribe(
      async (token) => {
        await this.storage.set("pushToken", token);
        await this.tokenController.registerDeviceToken(token);
        await this.channelService.postSubscribeToChannels(
          ["GlobalNotifications"],
          token
        );
      },
      async (err) => {
        console.log(err);
      }
    );
  }
}
